import { useState, useRef, useEffect } from 'react';
import Input from '../../../../../components/Input/Input';
import { IWingsGeometryProps, IWingsGeometrySteppedWeirForm } from './IWingsGeometry';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { setWingsGeometry } from '../../../store/project/projectSlice';
import { selectProject } from '../../../selector/conversion';
import { useTranslation } from 'react-i18next';
import { cleanResults } from '../../../store/project/resultsSlice';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { conversionLabel } from '../../../../conversion';
import { warning } from '../../../../../components/Alert/Alert';

const WingsGeometrySteppedWeir = (props: IWingsGeometryProps) => {
    let timer = useRef<NodeJS.Timeout | null>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const project = useAppSelector(selectProject);
    const projectInfo = useAppSelector(selectProjectInfo);

    const defaultValue: IWingsGeometrySteppedWeirForm = {
        offset: (project.data!.wingsGeometry as IWingsGeometrySteppedWeirForm).offset,
        width: (project.data!.wingsGeometry as IWingsGeometrySteppedWeirForm).width,
        height: (project.data!.wingsGeometry as IWingsGeometrySteppedWeirForm).height,
    };

    const [form, setForm] = useState<IWingsGeometrySteppedWeirForm>(defaultValue);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let name = e.target.name;
        let value = parseFloat(e.target.value);

        if (name === 'width' && value > project.data?.geometry?.channelWidth!) {
            value = project.data?.geometry?.channelWidth!;
            warning(t('warning_not_be_higher', { value: value }));
        }
        if (value < 0) {
            value = 0;
            warning(t('warning_not_be_lower', { value: 0 }));
        }

        setForm({
            ...form!,
            [name]: value,
        });
    };

    useEffect(() => {
        if (!!project.data?.geometry?.channelWidth && project.data?.geometry?.channelWidth < form.width)
            setForm({
                ...form!,
                width: project.data?.geometry?.channelWidth,
            });
    }, [project.data?.geometry?.channelWidth]);

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            dispatch(cleanResults());
            dispatch(setWingsGeometry(form as IWingsGeometrySteppedWeirForm));
        }, 1000);
    }, [form]);

    return (
        <div className='d-flex flex-column gap-2'>
            <Input
                type='number'
                title={t('input_crest_width', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                value={form.width}
                name='width'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_layerOffset', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                value={form.offset}
                name='offset'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
            <Input
                type='number'
                title={t('input_height', { unit_measure: conversionLabel.m_ft[projectInfo.data?.unitOfMeasure as number] })}
                value={form.height}
                name='height'
                className='d-flex justify-content-between align-items-center'
                onChange={handleInputChange}
            />
        </div>
    );
};

export default WingsGeometrySteppedWeir;
